import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name"]

  reset() {
    this.element.reset()
    if (this.hasNameTarget) {
      this.nameTarget.focus()
    }
  }
}
